export default __webpack_public_path__ + "static/media/image2.32331269.jpeg";